import {
  calculateBanobagiTransactionRights,
  summarizeBanobagiRights
} from "../utils/banobagiRights";

export const TRANSACTION_LIST_ENDPOINTS = Object.freeze([
  "/api/v1/Transaction/list_customer_transaction",
  "/api/Transaction/list_customer_transaction"
]);

async function requestWithFallback(endpoints, request, errorMessage) {
  let lastError = null;

  for (const endpoint of endpoints) {
    try {
      const response = await request(endpoint);
      if (response?.result == 1 && response.detail) return response;
      lastError = new Error(response?.message || "Unexpected response");
    } catch (error) {
      lastError = error;
    }
  }

  throw lastError || new Error(errorMessage);
}

export async function loadBanobagiRightsLedger(axios, filter) {
  const response = await requestWithFallback(
    TRANSACTION_LIST_ENDPOINTS,
    endpoint => axios.post(endpoint, filter),
    "Unable to load transactions"
  );
  const sourceTransactions = Array.isArray(response.detail?.transaction_list)
    ? response.detail.transaction_list
    : [];
  const transactions = sourceTransactions.map(transaction => ({
    ...transaction,
    _rights: calculateBanobagiTransactionRights(transaction)
  }));

  return {
    detail: response.detail,
    transactions,
    summary: summarizeBanobagiRights(transactions)
  };
}
